"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../colors"));
const breakpoints_1 = __importDefault(require("../breakpoints"));
const button = {
    MuiButton: {
        styleOverrides: {
            root: {
                transition: "width 0.5s ease-in-out",
                fontSize: "0.6rem",
                fontWeight: "bold",
                borderRadius: "30px",
                letterSpacing: "1px",
                minHeight: "50px",
                startIcon: {
                    fontSize: "0.8rem",
                },
                minWidth: "unset",
                padding: "8px 24px",
                [breakpoints_1.default.up("md")]: {
                    padding: "12px 28px",
                },
            },
            outlined: {
                "&.Mui-disabled": {
                    borderColor: colors_1.default.inputDisabled[100],
                    color: colors_1.default.inputDisabled[100],
                },
                padding: "8px 24px",
                [breakpoints_1.default.up("md")]: {
                    padding: "12px 28px",
                },
            },
            outlinedPrimary: {
                borderWidth: "2px",
                color: colors_1.default.primary[900],
                "&:hover": {
                    borderWidth: "2px",
                },
                "&:disabled": {
                    borderWidth: "2px",
                },
            },
            sizeSmall: {
                fontSize: "0.6rem",
                padding: "6px 14px",
                minHeight: "35px",
                [breakpoints_1.default.up("md")]: {
                    padding: "6px 18px",
                },
            },
            containedPrimary: {
                borderWidth: "2px",
                color: colors_1.default.secondary[900],
                backgroundImage: "linear-gradient(90deg, rgb(255, 186, 92) 6%, rgb(255, 135, 71) 100%)",
                backgroundSize: "300% 100%",
                borderRadius: "50px",
                "&:hover": {
                    backgroundSize: "300% 100%",
                    backgroundPosition: "100% 0",
                    backgroundImage: `linear-gradient(to right, #FFCA5C, ${colors_1.default.primary[900]}, #FE9A11,${colors_1.default.primary[900]} )`,
                },
                "&:disabled": {
                    borderWidth: "2px",
                },
                "&.Mui-disabled": {
                    backgroundImage: "none",
                    backgroundColor: `${colors_1.default.inputDisabled[900]} !important`,
                    color: `${colors_1.default.secondary[600]} !important`,
                },
            },
        },
    },
    MuiButtonBase: {
        styleOverrides: {
            root: {
                "&.Mui-disabled:not(.Mui-selected)": {
                    color: `${colors_1.default.inputDisabled[100]} !important`,
                },
            },
        },
    },
    MuiIconButton: {
        styleOverrides: {
            root: {
                "&:hover": {
                    backgroundColor: `${colors_1.default.secondary[600]}`,
                },
                "&.Mui-disabled  .MuiSvgIcon-root": {
                    color: `${colors_1.default.inputDisabled[900]} !important`,
                },
                minHeight: "inherit",
            },
        },
    },
};
exports.default = button;
